import { voidRequest } from 'paymentIntegrations/adyen/requests/adyenRequests';
import { FUNC_BUTTONS } from 'paymentIntegrations/types';
import { deletePaymentGroup } from 'paymentIntegrations/utils';
import { RootDispatch } from 'reducers';

import { creationOfAdyenPatchscript } from '../printing';
import { AdyenCardPaymentHooks } from '../types';

const adyenVoid = (payment, hooks: AdyenCardPaymentHooks) => async (
  dispatch: RootDispatch,
) => {
  const {
    updateMessage,
    enableButtons,
    displayWarning,
    adyenConfig,
    printReceipt,
  } = hooks;
  updateMessage('Voiding purchase...');

  try {
    const voidResponse = await voidRequest(payment);

    const { transactionStatus, statusMessage, additionalData } = voidResponse;

    if (transactionStatus === 'Success') {
      updateMessage(`Success. Void has been successfully performed.`);

      await dispatch(deletePaymentGroup(payment));

      if (adyenConfig.usePOSGeneralPrinter) {
        const parsedAdditionalData = JSON.parse(additionalData);
        const { receipts } = parsedAdditionalData;

        const receiptsPatchscript = creationOfAdyenPatchscript(receipts);
        printReceipt(receiptsPatchscript);
      }

      return true;
    }

    enableButtons([FUNC_BUTTONS.CLOSE]);
    updateMessage(`Unsuccessful Void: ${statusMessage}.`);
    return false;
  } catch (error) {
    enableButtons([FUNC_BUTTONS.CHECK_STATUS]);
    updateMessage(error.message);
    displayWarning(error.message);
    return false;
  }
};

export default adyenVoid;
